
















import {
	defineComponent,
	onMounted,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import * as SurveyCreator from 'survey-creator';
import 'survey-knockout/survey.css';
import 'survey-creator/survey-creator.css';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { getI18nSettingsStore } from '../i18n/store/i18nSettings';
import { PhoenixLocale } from '../i18n/model/locale';
import { getSurveysStore } from './store/SurveysStore';

SurveyCreator.StylesManager.applyTheme('darkblue');

const SURVEY_LOCALE: Record<Exclude<PhoenixLocale, PhoenixLocale.DEVICE_DEFAULT>, string> = {
	[PhoenixLocale.EN]: 'en',
	[PhoenixLocale.FR]: 'fr',
};

const OPTIONS = {
	showJSONEditorTab: true,
	showPagesToolbox: false,
	showPagesInTestSurveyTab: false,
};

type SurveySaveCallback = (id: string, success: boolean) => void;

export default defineComponent({
	components: { LoaderState, ErrorCard },
	props: {
		groupId: {
			type: String,
			required: true,
		},
		surveyId: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props) {
		watch(getI18nSettingsStore().getDisplayLocale, (curr) => {
			SurveyCreator.editorLocalization.currentLocale = SURVEY_LOCALE[curr];
		}, { immediate: true });
		const creator: Ref<SurveyCreator.SurveyCreator | null> = ref(null);
		const surveyStore = getSurveysStore();

		const {
			track,
			isLoading: isLoadingSurvey,
			isError: isErrorFetchingSurvey,
			isSuccess: isSuccessFetchingSurvey,
		} = useAsyncStatus();

		watch(() => props.surveyId, async (currentValue) => {
			if (currentValue) {
				await track(surveyStore.fetchSurvey(props.surveyId));
				if (!creator.value) {
					return;
				}
				creator.value.text = surveyStore.getSurvey(props.surveyId).surveyContent;
			}
		}, { immediate: true });

		onMounted(() => {
			creator.value = new SurveyCreator.SurveyCreator('creatorElement', OPTIONS);
			creator.value.saveSurveyFunc = async (saveId: string, callback: SurveySaveCallback) => {
				try {
					await surveyStore.updateSurveyForGroup(props.groupId, props.surveyId, {
						surveyContent: creator.value?.text || '{}',
					});
					callback(saveId, true);
				} catch (e) {
					// eslint-disable-next-line no-console
					console.error(e);
					callback(saveId, false);
				}
			};
			creator.value.text = surveyStore.getSurvey(props.surveyId).surveyContent;
		});

		return {
			isLoadingSurvey,
			isErrorFetchingSurvey,
			isSuccessFetchingSurvey,
		};
	},
});
